import { Routes } from "app/routes"
import { ErrorBoundary } from "app/core/components/ErrorBoundary"
import React, { ReactNode, useMemo } from "react"
import { useSession } from "app/auth/useSession"
import Link from "next/link"

type GracefulErrorDisplayProps = {
  icon: React.JSX.Element
  title: React.JSX.Element | string
  fullHeight?: boolean
  link?: ReactNode
}

export const GracefulErrorDisplayLink = () => {
  const session = useSession()

  const href = useMemo(() => {
    if (session.landingPage) {
      return session.landingPage
    } else {
      return Routes.MyTeamsPage()
    }
  }, [session])

  if (!!session.userId) {
    return (
      <Link href={href} className="btn btn-outline-dark m-2">
        <span className="d-flex align-items-center">
          <i className="bi bi-arrow-bar-left fs-5 me-1" />
          Back to your team
        </span>
      </Link>
    )
  } else {
    return (
      <Link href={Routes.LoginPage()} className="btn btn-outline-dark m-2">
        <span className="d-flex align-items-center">
          <i className="bi bi-box-arrow-in-right fs-5 me-2" />
          Log in
        </span>
      </Link>
    )
  }
}

export const GracefulErrorDisplay = ({
  icon,
  title,
  fullHeight,
  link,
}: GracefulErrorDisplayProps) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={fullHeight ? { minHeight: "50vh" } : {}}
    >
      {icon}
      <span className="text-muted my-3 fs-4">{title}</span>
      <ErrorBoundary fallbackRender={() => <></>}>
        {link ?? <GracefulErrorDisplayLink />}
      </ErrorBoundary>
    </div>
  )
}
